import { Component, inject } from '@angular/core';
import { LocalState } from '@common/localstate/frontend-shared';
import { AccessState, PageState } from '@core/frontend-shared';
import { FeatureMenuItem, FeatureMenuItemService } from '@core/frontend-shared/feature';
import { takeWhileAlive } from '@core/frontend-shared/utils';
import { fadeAnimation } from '@core/frontend-shared/utils/animations';
import { Store } from '@ngxs/store';

@Component({
    selector: 'mpf-admin-app',
    templateUrl: './app.component.html',
    styles: [
        `:host	{ display:block; height:100%; }
		.layout-content, user-authentication { display:block; height:100%; }
		`
    ],
    animations: [fadeAnimation],
    standalone: false
})
export class AppComponent {
	
	accessIsReady$ = inject(Store).select(AccessState.isReady) 
	loggedIn$ = inject(Store).select(AccessState.loggedIn) 
	isAdmin$ = inject(Store).select(AccessState.isAdmin) 
	userData$ = inject(Store).select(AccessState.accessData('user')) 
	pageTitle$ = inject(Store).select(PageState.title) 

	pinAdminMenu$ = inject(Store).select<boolean>(LocalState.get('pinAdminMenu')) 

	menuModel:FeatureMenuItem[];
	topMenuModel:FeatureMenuItem[];

	constructor(
		featureMenuItemService:FeatureMenuItemService,
	) { 

		featureMenuItemService.getAccessibleMenuItems('adminToolbar')
			.pipe(takeWhileAlive())
			.subscribe(menuItems=>{
				this.menuModel = [];
				menuItems.forEach((menuItem:FeatureMenuItem)=>{
					this.menuModel.push(menuItem)
				});
			})

		featureMenuItemService.getAccessibleMenuItems('adminTopMenu')
			.pipe(takeWhileAlive())
			.subscribe(menuItems=>{
				this.topMenuModel = [];
				menuItems.forEach((menuItem:FeatureMenuItem)=>{
					this.topMenuModel.push(menuItem)
				});
			})

	}


}
